import { Subject } from "@dooboostore/core";
import { ValidUtils } from "@dooboostore/core";
import { HttpJsonFetcher } from "@dooboostore/core";
var ApiServiceInterceptor;
((ApiServiceInterceptor2) => {
  ApiServiceInterceptor2.TOKEN = Symbol.for("simple-boot:api-service-interceptor-token");
  ApiServiceInterceptor2.resolveAll = (simstanceManager) => {
    try {
      return (simstanceManager.findSims(ApiServiceInterceptor2.TOKEN) ?? []).map((it) => it.getValue()).filter(ValidUtils.isDefined);
    } catch (e) {
      return [];
    }
  };
})(ApiServiceInterceptor || (ApiServiceInterceptor = {}));
const isStoreAfterFetch = (data) => {
  return data.type === "afterFetch";
};
const isStoreAfterFetchData = (data) => {
  return data.type === "afterFetchData";
};
const isStoreBeforeFetch = (data) => {
  return data.type === "beforeFetch";
};
const isStoreBeforeFetchData = (data) => {
  return data.type === "beforeFetchData";
};
const isStoreProgress = (data) => {
  return data.type === "progress";
};
const isStoreSuccess = (data) => {
  return data.type === "success";
};
const isStoreError = (data) => {
  return data.type === "error";
};
const isStoreFinal = (data) => {
  return data.type === "final";
};
class ApiService extends HttpJsonFetcher {
  constructor(simstanceManager, alertService) {
    super();
    this.simstanceManager = simstanceManager;
    this.subject = new Subject();
    this.alertService = alertService;
  }
  // @PostConstruct
  // postConstruct(alertService: AlertService<any>) {
  //   this.alertService = alertService;
  // }
  get observable() {
    return this.subject.asObservable();
  }
  createPipe(config) {
    return {};
  }
  async beforeProxyFetch(config) {
    let interceptors = ApiServiceInterceptor.resolveAll(this.simstanceManager);
    for (const interceptor of interceptors) {
      if (interceptor.beforeProxyFetch) {
        config = await interceptor.beforeProxyFetch(config);
      }
    }
    this.subject.next({ type: "beforeFetchData", config });
    return config;
  }
  async afterProxyFetch(config) {
    let interceptors = ApiServiceInterceptor.resolveAll(this.simstanceManager);
    let r = config.response;
    for (const interceptor of interceptors) {
      if (interceptor.afterProxyFetch) {
        r = await interceptor.afterProxyFetch(config);
      }
    }
    this.subject.next({ type: "afterFetchData", response: r });
    return r;
  }
  beforeFetch(fetch) {
    this.subject.next({ type: "beforeFetch", fetch });
  }
  afterFetch(fetch, response) {
    this.subject.next({ type: "afterFetch", fetch, response });
  }
  before(config, pipe) {
    this.subject.next({ type: "progress", config, pipe });
    config.config?.config?.callBackProgress?.(config, pipe);
    if (config.config?.config?.alertProgress) {
      const alert = this.alertService?.progress({ title: config.config.config.title });
      if (alert) {
        pipe.progress = alert;
        alert.activate();
      }
    }
  }
  afterSuccess(config, pipe) {
    this.subject.next({ type: "success", config, pipe });
    config.config?.config?.callBackSuccess?.(config, pipe);
    if (config.config?.config?.alertSuccessMsg) {
      this.alertService?.success({ title: config.config.config.title })?.activate();
    }
  }
  afterSuccessTransform(config, pipe) {
  }
  finally(config, pipe) {
    this.subject.next({ type: "final", config, pipe });
    config.config?.config?.callBackFinal?.(config, pipe);
    pipe.progress?.deActivate();
  }
  error(config, pipe, e) {
    console.log("error", e);
    this.subject.next({ type: "error", config, pipe, e });
    config.config?.config?.callBackError?.(config, pipe, e);
    if (config.config?.config?.alertErrorMsg) {
      this.alertService?.danger({
        title: `${config.config.config.title ? config.config.config.title : ""}${e.message ? `(${e.message})` : ""}`
      })?.activate();
    }
    if (config.config?.config?.enableErrorConsole) {
      console.error(`apiService Error ${config?.config?.config?.title}`, e);
    }
  }
  async execute(fetcherRequest) {
    const target = fetcherRequest.target;
    const config = fetcherRequest.config;
    let r = { target, config };
    const interceptor = ApiServiceInterceptor.resolveAll(this.simstanceManager) ?? [];
    for (const apiServiceInterceptor of interceptor) {
      if (apiServiceInterceptor.beforeProxyExecute) {
        r = await apiServiceInterceptor.beforeProxyExecute?.(r);
      }
    }
    return super.execute(r);
  }
}
export {
  ApiService,
  ApiServiceInterceptor,
  isStoreAfterFetch,
  isStoreAfterFetchData,
  isStoreBeforeFetch,
  isStoreBeforeFetchData,
  isStoreError,
  isStoreFinal,
  isStoreProgress,
  isStoreSuccess
};
//# sourceMappingURL=ApiService.js.map
